type DoseFields = {
  doseFrom: string | null;
  doseTo: string | null;
  doseUnit: string | null;
  doseType: string | null;
};

export function formatDoseUnitLabel(unit: string | null | undefined): string {
  if (unit === 'CFU') return 'cfu/g';
  if (unit === 'B_CFU_DAY') return 'B cfu/day';
  return unit ?? '';
}

export function formatDoseValue(
  value: string | null | undefined,
  unit: string | null | undefined,
): string {
  if (value == null || value === '') return '';
  const num = Number(value);
  if (Number.isNaN(num)) return value;
  if (unit === 'IU') return num.toLocaleString('de-DE');
  return num.toString();
}

export function formatDose(product: DoseFields): string {
  if (!product.doseFrom) return '';
  const unitLabel = formatDoseUnitLabel(product.doseUnit);
  const sep = unitLabel ? ' ' : '';
  const from = formatDoseValue(product.doseFrom, product.doseUnit);
  if (product.doseType === 'fixed') return `${from}${sep}${unitLabel}`;
  const to = formatDoseValue(product.doseTo, product.doseUnit);
  return `${from}–${to}${sep}${unitLabel}`;
}
